import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { StreamKeyword, TxKeyword, User } from '../../../../_models';
import { AuthenticationService, NotificationService,  EnvService, StreamKeywordService } from '../../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({ templateUrl: './stream-keyword-list.component.html' })
export class StreamKeywordListComponent implements OnInit {
  filterForm: FormGroup;
  newKeywordForm: FormGroup;
  keywords: StreamKeyword[];
  currentUser: User;
  shortCodeList: any = [];
  shortCodeFilterList = [];
  keywordList: any = [];
  operatorList: any = [];
  countryList: any = [];
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;
  sourceUrls: any = [];

  initialized = false;

  filterable = {
    shortCode: null,
    keyword: null,
    operator: null
  };

  constructor(private fb: FormBuilder,
    private envSvc: EnvService,
    private authSvc: AuthenticationService,
    private keywordSvc: StreamKeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.loadPage(1);
    this.loadSelection();
    this.loadSourceUrls();
  }

  openModal(targetModal, keyword = null) {
    if(!this.initialized){
      this.loadAllCountries();
      this.initialized = true;
    }
    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newKeywordForm = this.fb.group({
      shortCode: ['', Validators.required],
      keyword: ['', Validators.required],
      operator: ['', Validators.required],
      country: ['MY', Validators.required],
      min: [0, Validators.required],
      max: [0, Validators.required],
      rate: [100, Validators.required],
      url: [''],
      customizedUrl: [''],
      replacementPairs: [''],
    });
  }

  get f() { return this.newKeywordForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    this.filterable = {
      shortCode: null,
      keyword: null,
      operator: null,
    };
    this.keywordList = [];
    this.operatorList = [];
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onSubmit() {
    this.processing = true;
    var newDataParam = this.newKeywordForm.getRawValue();
    if (this.newKeywordForm.valid) {

      if (confirm("Are you sure to add the keyword now?")) {
        this.keywordSvc.addKeyword(newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Keyword added successfully!", "New Keyword");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add keyword, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  deleteKeyword(keyword) {
    if (confirm("Are you sure to delete this keyword?")) {
      this.keywordSvc.deleteKeyword(keyword.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Keyword deleted successfully!", "Delete Keyword");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting keyword, please try again later.", "Error");
        }
      })
    }
  }

  changeShortCode(shortCode) {
    console.log(shortCode);

    this.keywordList = [];
    this.operatorList = [];
    if(shortCode){
      this.keywordList = this.shortCodeList[shortCode];
      console.log(this.keywordList);

    }
  }

  changeKeyword(keyword){
    this.operatorList = [];
    if(keyword){
      this.operatorList = keyword.value;
    }
  }

  private loadSelection() {
    this.keywordSvc.getSelection().pipe(first()).subscribe(data => {
      this.shortCodeList = data.data;
      this.shortCodeFilterList = Object.keys(this.shortCodeList);
    });
  }

  private loadAllCountries() {
    this.envSvc.getCountries().pipe(first()).subscribe(data => {
      this.countryList = data.data;
      console.log(this.countryList);
    });
  }

  private loadSourceUrls(){

    this.sourceUrls = [];
    this.sourceUrls.push({'source':'Pay365', 'url':'http://pays2s.intelligent-earnings.com/stream/pay365'});

  }
  private loadPage(page = null) {
    this.loading = true;
    this.keywords = [];
    let params = this.formParam(page);

    // get page of items from api
    this.keywordSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.keywords = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null ? "" : this.filterable.keyword.key,
      operator: this.filterable.operator,
    }
    return params;
  }

}
